import React from 'react';

import Layout from 'layouts/Layout';
import Profil from './Profil';

const ProfilLayout = () => <Layout component={Profil} />;

export default ProfilLayout;
